import { render } from "./sticky-action-bar.vue?vue&type=template&id=29141ad4"
import script from "./sticky-action-bar.vue?vue&type=script&lang=js"
export * from "./sticky-action-bar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__